<template>
  <div class="content-box">
    <div class="colse-btn" @click="closeDia">&Cross;</div>
    <div class="content-wrap">
      <div class="title">{{ form.firmName }}</div>
      <div class="content">
        <div class="left">
          <div
            :class="activeIndex == index ? 'left-item active' : 'left-item'"
            v-for="(item, index) in leftMenu"
            :key="item.id"
            @click="menuActive(index)"
          >
            <img :src="item.url" />
            <div>{{ item.name }}</div>
          </div>
        </div>
        <div class="right">
          <div class="gs-box" v-if="activeIndex == 0">
            <Business :form="form"></Business>
          </div>
          <div class="gs-box" v-if="activeIndex == 1">
            <Subject :form="form"></Subject>
          </div>
          <div class="gs-box" v-if="activeIndex == 2">
            <Corporate :form="form"></Corporate>
          </div>
          <div class="gs-box" v-if="activeIndex == 3">
            <Relations :form="form"></Relations>
          </div>
          <div class="gs-box" v-if="activeIndex == 4">
            <Evaluation :form="form"></Evaluation>
          </div>
          <div class="gs-box" v-if="activeIndex == 5">
            <Enterprise :form="form"></Enterprise>
          </div>
          <div class="gs-box" v-if="activeIndex == 6">
            <Excellent :form="form"></Excellent>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Business from "@/components/businessRegistration.vue";
import Subject from "./subjectAnalysis.vue";
import Corporate from "./corporatePortrait.vue";
import Evaluation from "./evaluationReport.vue";
import Enterprise from "./enterpriseMonitoring.vue";
import Excellent from "./excellentEnterprise.vue";
import Relations from "./relationshipGraph.vue";
export default {
  props: {
    form: Object
  },
  components: {
    Business,
    Subject,
    Corporate,
    Evaluation,
    Enterprise,
    Excellent,
    Relations,
  },
  data() {
    return {
      leftMenu: [
        {
          id: 1,
          name: "工商登记",
          url: require("../assets/images/menu1.png"),
        },
        {
          id: 2,
          name: "主体分析",
          url: require("../assets/images/menu2.png"),
        },
        {
          id: 3,
          name: "企业画像",
          url: require("../assets/images/menu3.png"),
        },
        {
          id: 4,
          name: "关联图谱",
          url: require("../assets/images/menu4.png"),
        },
        {
          id: 5,
          name: "评价报告",
          url: require("../assets/images/menu5.png"),
        },
        {
          id: 6,
          name: "企业监控",
          url: require("../assets/images/menu6.png"),
        },
        {
          id: 7,
          name: "优企挖掘",
          url: require("../assets/images/menu7.png"),
        },
      ],
      activeIndex: 0,
    };
  },
  methods: {
    // 关闭弹窗
    closeDia() {
      this.$emit("handleClose", false);
    },
    // 菜单切换
    menuActive(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style scoped lang="scss">
.content-box {
  background: #062349;
  // padding: 0.2rem;
  width: 12rem;
  height: auto;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10000;
  .colse-btn {
    border-radius: 50%;
    border: 1px solid rgb(0, 205, 252, 0.8);
    font-size: 0.16rem;
    width: 0.2rem;
    height: 0.2rem;
    text-align: center;
    line-height: 0.16rem;
    color: #fff;
    float: right;
    margin: 0.05rem;
    cursor: pointer;
  }
  .content-wrap {
    border: 1px solid #00cdfc;
    //margin: 0.5rem 0.3rem;
    padding: 0.1rem;
    height: 100%;
    .title {
      font-size: 0.1rem;
      background: linear-gradient(to bottom, #d0fdff, #56f7ff);
      background-clip: text;
      color: transparent;
      text-align: center;
      border-bottom: 3px solid;
      border-image: -webkit-linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          #00bbf2 20%,
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: -moz-linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          #00bbf2 20%,
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      border-image: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          #00bbf2 20%,
          rgba(255, 255, 255, 0) 99%
        )
        2 2 2 2;
      width: 15%;
      padding: 0.1rem;
      margin: 0 auto;
    }
    .content {
      display: flex;
      //   align-items: center;
      margin-top: 0.1rem;
      .left {
        width: 20%;
        // height: 100%;
        display: flex;
        flex-wrap: wrap;
        // justify-content: center;
        font-size: 0.1rem;
        border: 1px solid #00cdfc;
        background: linear-gradient(to bottom, #d0fdff, #56f7ff);
        background-clip: text;
        color: transparent;
        font-weight: 600;
        text-align: center;
        .left-item {
          width: 100%;
          padding: 0.05rem 0.1rem;
          display: flex;
          align-items: center;
          cursor: pointer;

          img {
            width: 0.18rem;
            height: 0.18rem;
            margin-right: 0.2rem;
          }
        }
        .active {
          position: relative;
          cursor: pointer;
          box-shadow: 0 0 20px 5px rgba(0, 205, 252, 0.3) inset;
          background-clip: text;
          -webkit-background-clip: text;
          color: transparent;
          background-image: linear-gradient(
            90deg,
            rgb(69, 122, 255),
            rgb(134, 238, 254),
            rgb(76, 132, 229),
            rgb(31, 73, 145),
            rgb(67, 174, 255),
            rgb(164, 164, 167),
            rgb(122, 239, 225),
            rgb(134, 254, 246),
            rgb(69, 255, 236)
          );
          background-size: 200%;
          animation: streamer 2s linear infinite;
        }
        @keyframes streamer {
          from {
            box-shadow: 0 0 18px rgba(0, 191, 255) inset;
            background-position: 0%;
          }
          50% {
            box-shadow: 0 0 18px rgba(0, 205, 252, 0.3) inset;
            background-position: 100%;
          }
          to {
            box-shadow: 0 0 18px rgba(0, 191, 255) inset;
            background-position: 200%;
          }
        }
      }
      .right {
        width: 80%;
        font-size: 0.1rem;
        margin-left: 0.1rem;
        color: #01c5f3;
        height: 4.35rem;
        .right-title {
          border-left: 2px solid #01c5f3;
          padding: 0 0.1rem;
          font-size: 0.1rem;
          font-weight: 550;
        }
        .gs-box {
          height: 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .content-box {
    .colse-btn{
      line-height: .18rem;
    }
    .content-wrap{
      height: 5.5rem;
      .content .right{
        height: 5rem;
      }
    }
  }
}
</style>
